import React, {useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
//import { Link } from "react-router-dom";
import Card from "../../components/common/Card";

import Linechart from "../../components/ReportComponents/LineChart";
import CampaignTable from "../../components/ReportComponents/CampaignTable";
import PublishersTable from "../../components/ReportComponents/PublishersTable"

import { getTopBoard } from "../../redux/slices/reportSlice";
//import CampaignTable from "../../components/DashboardComponents/CampaignTable";

import { Container, CardWrapper, ChartWrapper, TableWrapper } from "./ReportStyles";

const Report = () => {
  const dispatch = useDispatch();
  const { topBoard } = useSelector((state) => state.report);

  useEffect(() => {
    dispatch(getTopBoard());
  }, [dispatch]);
  return (
    <Container>
      <div className="header">
        <div className="texts">
          <h3>Monthly Reports</h3>
          <p>View your team’s trades and transactions.</p>
        </div>

        <div className="link-buttons">
          {/* <Link className="see-more" to="/campaigns">
            Export
          </Link> */}
          {/* <Link className="add-campaign" to="/create-publisher">
            + Create campaign
          </Link> */}
        </div>
      </div>

      <CardWrapper>
        <Card text={"Total no of campaigns"} totalCount={topBoard.totalCampaigns} />
        <Card text={"Total no of advertisers"} totalCount={topBoard.totalAdvertisers} />
        <Card text={"Total no of publishers"} totalCount={topBoard.totalPublishers} />
      </CardWrapper>
      
      <h3>Performance Analytics</h3>
      <ChartWrapper>
      <Linechart />
      </ChartWrapper>

      <TableWrapper>
        <div className='header'>
          <div className='texts'>
            <h4>Campaigns</h4>
            <p>Keep track of your Ads with MetaClick</p>
          </div>
        </div>
        <CampaignTable />
      </TableWrapper>

      <TableWrapper>
        <div className='header'>
          <div className='texts'>
            <h4>Publisher</h4>
            <p>Keep track of your Ads with MetaClick</p>
          </div>
        </div>
        <PublishersTable />
      </TableWrapper>
    </Container>
  );
};

export default Report;

